module.exports = __webpack_public_path__ + "img/500_Phishing.67544041.png";